/* Built In Imports */

/* External Imports */
import { Box, Heading, Image, Link, List, ListItem } from '@chakra-ui/react';
import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton
} from 'react-share';

/* Internal Imports */
/* Components */
import config from '@config';
import { Likes } from '@msr/components/Utility/Likes';

/* Services */

/**
 *
 * @param {string} url
 * @returns
 */
const SocialIconMob = ({
  url,
  isLikeVisible = true,
  direction,
  position,
  data,
  likesCount,
  style = 'normal',
  display,
  shareTextColor,
  isMobile,
  ...props
}) => {
  return (
    <List
      pos={{ base: position || 'fixed', lg: position || 'fixed' }}
      zIndex="10"
      bottom={{ base: '65px', md: '' }}
      top={{ base: '76%', lg: '50%' }}
      display={{ base: 'flex', md: 'none', xl: 'none' }}
      // display={display || { base: 'block', md: 'none', xl: 'grid' }}
      left={{ base: '13.38px', md: '1%', lg: '5%' }}
      justifyItems="center"
      alignItems="center"
      textAlign="center"
      {...props}
    >
      {isLikeVisible && <Likes data={data} likesCount={likesCount} dir="row" />}
      <Box
        borderTop={{
          base: 'none',
          lg: isLikeVisible ? '1px solid #8F92C1' : 'none',
        }}
        borderRight={{
          base: '1px solid #8F92C1',
          // base: 'none',
          md: 'none',
        }}
        display={{ base: 'flex', lg: 'block' }}
        pb={{ base: '20px', lg: '20px' }}
        pt={{ base: '20px', lg: 0 }}
        mt={{ base: '0', lg: '20px' }}
        width={{ base: '20px', lg: 'full' }}
      />

      <Heading
        as="h6"
        color={'#8F92C1'}
        fontSize="18px"
        pl={{ base: '21px', lg: 0 }}
        pr="13px"
        pb={{ base: '0', md: '10px' }}
      >
        Share
      </Heading>

      <ListItem w="40px" m={{ lg: '0', md: '10px 0' }}>
        <FacebookShareButton url={`${config.BASE_PATH}${url}`} quote={''}>
          <Link
            mb={{ base: 0, sm: 0, md: 0, lg: '10px' }}
            display="block"
            href={`https://www.addtoany.com/add_to/facebook?linkurl=${config.BASE_PATH}${url}`}
          >
            <Image
              w="28px"
              h="28px"
              src={`${config.imgPath}/d/46272/1666383820-fb-msr.png`}
            />
          </Link>
        </FacebookShareButton>
      </ListItem>
      <ListItem w="40px" m={{ lg: '0', md: '10px 0' }}>
        <TwitterShareButton url={`${config.BASE_PATH}${url}`} title={''}>
          <Link
            mb={{ base: 0, sm: 0, md: 0, lg: '10px' }}
            display="block"
            href={`https://www.addtoany.com/add_to/twitter?linkurl=${config.BASE_PATH}${url}`}
          >
            <Image
              w="28px"
              h="28px"
              src={`${config.imgPath}/d/46272/1666383825-twitter-msr.png`}
            />
          </Link>
        </TwitterShareButton>
      </ListItem>
      <ListItem w="40px" m={{ lg: '0', md: '10px 0' }}>
        <WhatsappShareButton
          url={`${config.BASE_PATH}${url}`}
          title={''}
          separator=":: "
        >
          <Link
            mb={{ base: 0, sm: 0, md: 0, lg: '10px' }}
            display="block"
            href={`https://www.addtoany.com/add_to/whatsapp?linkurl=${config.BASE_PATH}${url}`}
          >
            <Image
              w="28px"
              h="28px"
              src={`${config.imgPath}/d/46272/1666383828-whatsapp-msr.png`}
            />
          </Link>
        </WhatsappShareButton>
      </ListItem>
    </List>
  );
};

export default SocialIconMob;
